import React from "react";
import InlinePageSizeSelector from "../InlinePageSizeSelector/InlinePageSizeSelector";
import Pagination from "../Pagination/pagination";
import "./ModernGridPagerFooter.css";

/**
 * Bottom footer: page size + entry summary (left), pagination controls (right).
 * Page controls hidden when totalPages <= 1.
 */
const ModernGridPagerFooter = ({
  pageSize,
  onPageSizeChange,
  totalRecords,
  pageNumber,
  totalPages,
  setPageNumber,
}) => {
  const pageSizeNum = Number(pageSize?.value ?? pageSize);
  const showPageControls = totalPages > 1;

  return (
    <div className="modern-grid-pager-footer">
      <div className="modern-grid-pager-footer__start">
        <div className="modern-grid-pager-footer__page-size">
          <span className="modern-grid-pager-footer__label">Show per page:</span>
          <InlinePageSizeSelector
            defaultValue={pageSize}
            onChange={onPageSizeChange}
          />
        </div>
        <Pagination
          variant="inline"
          showPageControls={false}
          totalRecords={totalRecords}
          pageSize={pageSizeNum}
          pageNumber={pageNumber}
          totalPages={totalPages}
          setPageNumber={setPageNumber}
        />
      </div>
      {showPageControls && (
        <div className="modern-grid-pager-footer__end">
          <Pagination
            variant="inline"
            showSummary={false}
            totalRecords={totalRecords}
            pageSize={pageSizeNum}
            pageNumber={pageNumber}
            totalPages={totalPages}
            setPageNumber={setPageNumber}
          />
        </div>
      )}
    </div>
  );
};

export default ModernGridPagerFooter;
